import { CartItemType } from '@interface/common';

export const PRODUCT: CartItemType = `product`;
export const BUNDLE: CartItemType = `bundle`;
